<template>
  <div>
    <Navbar v-if="$route.name == 'elearningmaterials'"/>
    <Breadcrumb v-if="$route.name == 'elearningmaterials'" />
    <div v-show="material_id == 0">
      <div class="row">
        <div class="col-3 mt-3 mb-3">
          <button @click.prevent.stop="addmaterial" class="btn btn-primary gdq_faded">
            <span class="icon-plus me-2"></span>Add material
          </button>
        </div>
        <div class="col-3 mt-3 mb-3">
          <div class="input-group input-group-sm">
            <input
              v-model="search"
              placeholder="Search heading"
              type="text"
              @input="materials_filter"
              autocomplete="off"
              class="form-control"
            />
            <button
              class="btn btn-outline-secondary"
              type="button"
              @click="search = ''"
            >
              X
            </button>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-hover table-fixed">
          <thead>
            <tr>
              <th 
                v-for="field in fields" 
                :key="field.key"
                :class="field.thClass"
                @click="field.sortable ? materials_sort({sortBy: field.key, sortDesc: orderby === field.key ? !orderdesc : false}) : null"
                :style="field.sortable ? 'cursor: pointer;' : ''"
              >
                <div v-if="field.key === 'select'" class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :checked="selected"
                    @click.stop
                    @change="selectall(selected)"
                  />
                  <label class="form-check-label">
                    <span class="text-muted" v-if="selectcount>0">({{selectcount}})</span>
                  </label>
                </div>
                <span v-else>
                  {{ field.label }}
                  <span v-if="orderby === field.key && field.sortable">{{ orderdesc ? ' ▼' : ' ▲' }}</span>
                </span>
              </th>
            </tr>
          </thead>
          <tbody v-if="loading">
            <tr>
              <td :colspan="fields.length" class="text-center text-primary my-2">
                <div class="spinner-border spinner-border-sm" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr 
              v-for="(item, index) in materials" 
              :key="item.id"
              @click="editmaterial(item)"
              style="cursor: pointer;"
            >
              <td :class="fields[0].tdClass">
                <div class="py-1">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :id="'selected'+index"
                      v-model="item.selected"
                      @click.stop
                      @change="countselected"
                    />
                  </div>
                </div>
              </td>
              <td :class="fields[1].tdClass">
                <div class="py-1">
                  {{ item.material_heading }}
                </div>
              </td>
              <td :class="fields[2].tdClass">
                <div class="py-1">
                  {{ item.material_filename }}
                </div>
              </td>
              <td :class="fields[3].tdClass">
                <span 
                  @click.prevent.stop="deletematerial(item.id)"
                  style="cursor: pointer;"
                >
                  <fa-icon name="trash-alt" />
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <Pagination
        :current-page="currentPage"
        :per-page="perPage"
        :total-rows="rows"
        aria-label="Learning Materials pagination"
        @page-changed="currentPage = $event"
      />
    </div>
    <div v-show="material_id != 0">
      <LearningMaterial />
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import LearningMaterial from './LearningMaterial';
import Navbar from './Navbar.vue';
import Breadcrumb from './Breadcrumb.vue';
import Pagination from './Pagination.vue';

const fields = [
  { key: 'select', label: '', sortable: false, thClass: 'col gdq-w-10', tdClass: 'col gdq-w-10' },
  { key: 'material_heading', label: 'Heading', sortable: true, thClass: 'col', tdClass: 'col' },
  { key: 'material_filename', label: 'File', sortable: true, thClass: 'col', tdClass: 'col' },
  { key: 'empty', label: '', sortable: false, thClass: 'col gdq-w10', tdClass: 'col gdq-w-10' },
];
export default {
  components: {
    LearningMaterial,
    Navbar,
    Breadcrumb,
    Pagination,
  },
  name: 'LearningMaterials',
  mounted() {
    this.materials_get()
  },
  data: function() {
    return {
      search: '',
      searching: false,
      searchcalc: false,
      fields: fields,
      materials: [],
      allowmultiselect: false,
      muteclass: 'text-muted',
      currentPage: 1,
      perPage: 10,
      rows: 0,
      loading: null,
      orderby: 'material_heading',
      orderdesc: false,
      selected: 0,
      bulkaction: 0,
      selectcount: 0,
    }
  },
  computed: {
    material_id: {
      get() {
        return this.$store.state.currentelearningmaterial_id;
      }
    },
    materialchanged: {
      get() {
        return this.$store.state.elearningmaterialchanged;
      }
    },
  },
  watch: {
    currentPage: function() {
      this.materials_get();
    },
    search: function() {
      this.searching = true
      this.materials_filter()
    },
    materialchanged: function() {
      if (this.$store.state.materialchanged != 0) {
        this.material_get(this.$store.state.materialchanged);
        this.$store.dispatch('elearningmaterialchanged_set',{ material_id: 0 });
      }
    },
    material_id: function() {
      this.materials_get();
    },
  },
  methods: {
    deletematerial(id) {
      this.$store.dispatch('elearningmaterial_delete', { material_id: id })
      .then(() => {
        this.materials_get();
      });
    },
    addmaterial() {
      this.$store.dispatch('elearningmaterial_setcurrent',{ material_id: -1 })
      .then(() => {
        this.materials_get();
      });
    },
    editmaterial(item) {
      this.$store.dispatch('elearningmaterial_setcurrent',{ material_id: item.id })
      .then(() => {
        this.materials_get();
      });
    },
    material_get(material_id) {
      var material_heading = '';
      this.$store.dispatch('elearningmaterial_fetch', { material_id: material_id })
      .then((resp) => {
        material_heading = resp.data.material_heading;
        for (var i=0; i<this.materials.length; i++) {
          if (this.materials[i].id == material_id) {
            this.materials[i].material_heading = material_heading;
          }
        }
      });
    },
    selectall(selected) {
      var setselectto = !selected;
      for (var i=0;i<this.materials.length; i++) {
        this.materials[i].selected = setselectto;
      }
      this.countselected();
    },
    countselected() {
      this.$nextTick(() => {
        var selectcount = 0;
        for (var i=0;i<this.materials.length; i++) {
          if (this.materials[i].selected) {
            selectcount++;
          }
        }
        this.selectcount = selectcount;
      })
    },
    materials_filter: _.debounce(function() {
      this.searchcalc = true
      setTimeout(function() {
        this.materials_get();
        this.searchcalc = false;
        this.searching = false;
      }.bind(this),500)
    },300),
    materials_sort(context) {
      this.orderby = context.sortBy;
      this.orderdesc = context.sortDesc;
      this.materials_get();
    },
    materials_get() {
      this.loading = true;
      var filter = '';
      if (this.search != '') {
        filter = {
          material_heading: {
            operator: 'LIKE',
            value: '%'+this.search+'%',
          },
        }
      } else {
        filter = {
          id: {
            operator: ' > ',
            value: 0,
          }
        }
      }
      this.$store.dispatch('elearningmaterials_fetch', {
        start: (this.currentPage-1)*this.perPage,
        limit: this.perPage,
        orderby: this.orderby,
        order: (this.orderdesc==false)?'ASC':'DESC',
        filter: filter,
      })
      .then((resp) => {
         this.materials = [];
         for (var i=0;i<resp.data.result.length;i++) {
           var result = {
             id: resp.data.result[i].id,
             selected: false,
             material_heading: resp.data.result[i].material_heading,
             material_filename: resp.data.result[i].material_filename,
           }
           this.materials.push(result);
         }
         this.rows = resp.data.total;
         this.loading = false;
      });
    },
  },
}
</script>
<style>
.gdq-faded {
  opacity: 0.5;
}
</style>
